import { RouteConfig } from '@/modules/core/app/helpers/RouteConfig';
import { Component } from 'vue';

export class AuthLoginRouteConfig extends RouteConfig {
  async getComponent(): Promise<Component | null> {
    return import('/@/modules/auth/pages/LoginPage.vue');
  }
}
